import {AppNavigator} from "../../components/AppNavigator";
import React, {useMemo} from "react";
import {Autocomplete, Box, IconButton, TextField} from "@mui/material";
import data from "data/searchData.json";
import './SearchPage.css'
import {createSearchParams, Outlet, useNavigate, useParams, useSearchParams} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


export function SearchPage() {
  const options = data.map(park => ({label: park.name ?? "", id: park.id, location: park.searchArea}))
  const {parkId} = useParams()
  const [params] = useSearchParams()

  const selectedOption = useMemo(() => {
    return options.find(option => option.id === parkId)
  }, [parkId, options])
  const navigate = useNavigate()

  const location = useMemo(() => {
    if (params) {
      const lat = params.get("lat")
      const lon = params.get("lon")
      const zoom = params.get("zoom")
      if (lat && lon && zoom) {
        return {lat: parseFloat(lat), lon: parseFloat(lon), zoom: parseFloat(zoom)}
      }
    }
    if (selectedOption && selectedOption.location) {
      return {lat: selectedOption.location.lat, lon: selectedOption.location.lon, zoom: 13}
    }
  }, [params, selectedOption])

  return <div className={"SearchPage"}>
    <div className={"SearchPageContent"}>
      <div className={"SearchPage-topSearchNav"}>
        {selectedOption && location &&
            <IconButton
                style={{padding: 0}}
                aria-label="back"
                size={'large'}
                onClick={() =>
                  navigate({
                    pathname: '/map',
                    search: `${createSearchParams({
                      lat: `${location.lat}`,
                      lon: `${location.lon}`,
                      zoom: `${location.zoom}`
                    })}`,
                  })
                }
            >
                <ArrowBackIcon fontSize={"large"}/>
            </IconButton>}
        <Autocomplete
          defaultValue={selectedOption}
          getOptionLabel={(option) => option?.label ?? ""}
          renderInput={(params) => <TextField {...params} label="Search"/>}
          renderOption={
            (props, option) =>
              <Box {...props} component="li" key={option.id} onClick={(e) => {
                navigate(option.id)
                props.onClick && props.onClick(e)
              }}>{option.label}</Box>
          }
          options={options}
          className={"SearchPage-searchBar"}
        />
      </div>
      <Outlet/>
    </div>
    <div className={'SearchPageNavBar'}>
      <AppNavigator overRides={{path: "/search"}}/>
    </div>
  </div>
}